<template>
  <div class="news-box">
    <div class="news-ul">
      <div class="news-li" v-for="(item, index) in news" :key="index" @click="gotonewsDetails(item)">
        <img v-if="item.image && item.image.url != undefined" :src="item.image.url" />
        <img v-else src="@/assets/images/logo-img.png" alt="">
        <div class="news-text">
          <div class="news-h">{{ item.title }}</div>
          <div class="news-p">{{ item.introduction }}</div>
          <div class="news-time">{{ item.createTimeFormat }}</div>
        </div>
      </div>
    </div>
    <el-pagination class="paging" background :current-page="page.number" :page-sizes="[6, 10, 20, 30]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total" @size-change="sizeChange"
      @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick"></el-pagination>
  </div>
</template>

<script>
import { getPageDetails } from '@/api/home'
export default {
  name: "news",
  props: {
    news: {
      type: Array,
      required: true // 父组件传递课程列表
    },
    page: {
      type: Object,
      default: {}
    }
  },
  methods: {
    gotonewsDetails(value) {
      if(value.isForward) {
        this.getPageDetails(value.id)
        window.open(value.h5Url, '_blank')
      }else {
        this.$router.push({ path: `/NewsDetailsTwo/${value.id}` }); // 动态路由传递课程 id
      }
      // this.$router.push({ path: `/NewsDetails` }); // 动态路由传递课程 id
    },
    // 按 id 查询新闻资讯、质控课程、质控公告
    getPageDetails(id) {
      getPageDetails({
        id: id
      }).then(res => {
      })
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  }
}
</script>

<style lang="less" scoped>
.news-ul {
  margin-top: 20px;

  .news-li {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 16px 14px;
    margin-bottom: 14px;
    border-radius: 6px;
    cursor: pointer;

    img {
      width: 160px;
      height: 120px;
      display: block;
      margin-right: 14px;
    }

    .news-text {
      width: calc(100% - 174px);
      text-align: left;

      .news-h {
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        color: #222222;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
      }

      .news-p {
        font-size: 14px;
        color: #626365;
        line-height: 24px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-top: 8px;
      }

      .news-time {
        color: #626365;
        font-size: 14px;
        margin-top: 14px;
      }
    }
  }
}

/deep/.el-input__inner {
  height: 32px;
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/base/news.vue